"use client";

import { useEffect, useRef, type RefObject } from "react";

export function useInViewOnce(
  ref: RefObject<Element | null>,
  onView: () => void,
  threshold = 0.25,
) {
  const callback = useRef(onView);

  useEffect(() => {
    callback.current = onView;
  });

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          obs.disconnect();
          callback.current();
        }
      },
      { threshold },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, threshold]);
}
